var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#362FD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#362FD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_7393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 20.5913 16.6321 22.1174 17.7574 23.2426C18.8826 24.3679 20.4087 25 22 25C23.5913 25 25.1174 24.3679 26.2426 23.2426C27.3679 22.1174 28 20.5913 28 19C28 17.4087 27.3679 15.8826 26.2426 14.7574C25.1174 13.6321 23.5913 13 22 13C20.4087 13 18.8826 13.6321 17.7574 14.7574C16.6321 15.8826 16 17.4087 16 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 25L25.4 30.89L26.998 27.657L30.596 27.889L27.196 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8023 22L13.4023 27.89L17.0003 27.657L18.5983 30.889L21.9983 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_7393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIco);
export default __webpack_public_path__ + "static/media/rewardIco.e536f53fb94b39bf07587df7e14e6760.svg";
export { ForwardRef as ReactComponent };